export default "__VITE_ASSET__DutF6TSt__"